export default __webpack_public_path__ + "static/Delivery-Hero-Logo-64cbc2f748aa8a680ccf778b6df13faf.png";